module.exports = __webpack_public_path__ + "img/qx_icon3.de7c19ec.png";